export default "__VITE_ASSET__Cz1$UWnn__"